import { render, staticRenderFns } from "./AlbumView.vue?vue&type=template&id=5544c810&scoped=true&"
import script from "./AlbumView.vue?vue&type=script&lang=js&"
export * from "./AlbumView.vue?vue&type=script&lang=js&"
import style0 from "./AlbumView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AlbumView.vue?vue&type=style&index=1&id=5544c810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5544c810",
  null
  
)

export default component.exports